import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
    marginLeft: 5,
  },
  textField: {
    marginTop: 13,
  },
  marginDefault: {
    margin: theme.spacing(1),
  },
  marginText: {
    fontSize: 12, marginTop: 4, marginLeft: theme.spacing(1),
  },
}));
